export const ADD_PUSH_TOKEN = `notifications/ADD_PUSH_TOKEN`
export const LISTEN_TO_PUSH_NOTIFICATIONS = `notifications/LISTEN_TO_PUSH_NOTIFICATIONS`
export const NOTIFICATION_REVEICED_IN_APP = `notifications/NOTIFICATION_REVEICED_IN_APP`
export const PUSH_NOTIFICATION_SELECTED = `notifications/PUSH_NOTIFICATION_SELECTED`
export const CLEAR_IN_APP_NOTIFICATION = `notifications/CLEAR_IN_APP_NOTIFICATION`
export const CLEAR_PUSH_NOTIFICATION = `notifications/CLEAR_PUSH_NOTIFICATION`
export const NAVIGATE_TO_NOTIFICATION = `notifications/NAVIGATE_TO_NOTIFICATION`
